import 'proxy-polyfill/proxy.min.js'
import { has, snakeCase, camelCase } from 'lodash'

export default class Decorator {
  constructor (decorated) {
    this.decorated = decorated

    return new Proxy(this, {
      get (target, property, receiver) {
        let snakedProperty = snakeCase(property)
        let camelProperty = camelCase(property)

        // If the property exists on the target decorator we'll send it straight there...
        if (has(target, property)) {
          return target[property]

        // We'll also look for a snaked case of it...
        } else if (has(target, snakedProperty)) {
          return target[snakedProperty]

        // And just for consistency a camel case of it...
        } else if (has(target, camelProperty)) {
          return target[camelProperty]

        // Now we'll see if it's a function!
        } else if (typeof target[camelProperty] === 'function') {
          // If the camel property is a function on the target decorator then we'll treat
          // is as such and attempt to call it. we create a function  definition and
          // inside we apply the function within a try to avoid errors. We pass the
          // receiver which should be this Proxy as the "this" and we also pass in
          // the args.
          let argumentCount = target[camelProperty].length

          let functionDefinition = (...args) => {
            try {
              return target[camelProperty].apply(receiver, args)
            } catch (error) {
              //
            }
          }

          // We count the arguments we received because if the function has none then
          // we do not and should not call it as such, instead it should be called as
          // a property and we'll simply call it as per usual.
          if (argumentCount > 0) {
            return functionDefinition
          } else {
            return functionDefinition.call(receiver)
          }
        }

        // Otherwise we'll check if we have the property on the decorated object...
        if (has(target.decorated, property)) {
          return target.decorated[property]
        } else if (has(target.decorated, snakedProperty)) {
          return target.decorated[snakedProperty]
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/decorators/decorator.js